var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poper-panel__total",class:_vm.theme},[_c('div',{staticClass:"poper-panel__content",style:(_vm.styleObj)},[_c(_vm.content,{tag:"component",on:{"cancle":_vm.cancle,"confirm":_vm.confirm}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }